import style from "./style.scss";
import { mergeClasses } from "../helpers";

const Center = ({
  light = true,
  color = undefined,
  children,
  overflow = false,
  compact = false,
}) => (
  <div
    class={mergeClasses([
      style.center,
      light ? style.light : null,
      overflow ? style.overflowVisible : null,
      compact ? style.compact : null,
    ])}
    style={`background-color:${color}`}
  >
    <div class={style.wrapper}>{children}</div>
  </div>
);

export default Center;
